import { FC, useMemo } from "react";

export const FaviconPreview: FC<{ url: string }> = ({ url }) => {
  const imageUrl = useMemo(() => {
    return /^([a-zA-Z0-9. _-])+$/.test(url) ? `https://icons.duckduckgo.com/ip6/${url}.ico` : null
  }, [url])
  if (!imageUrl) return <div className={"h-6 w-6 rounded-xs bg-slate-100"}></div>
  return <div className={"h-6 w-6 rounded-sm"} style={{ background: `url(${imageUrl})`, backgroundSize: "contain" }} />
}
